// extracted by mini-css-extract-plugin
export default {"container":"DndWrapper-container___CGF4Y","background":"DndWrapper-background___XZqQy","zone":"DndWrapper-zone___bV3pu"};